import { render } from "./SelectUsers.vue?vue&type=template&id=dffd685e"
import script from "./SelectUsers.vue?vue&type=script&lang=js"
export * from "./SelectUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__